<template>
    <div v-if="comStore.Categories?.value.length === 0">
        <AlertMessage
            type="info"
            :show-icon="false"
        >
            <div class="d-flex gap-5">
                <IconComp
                    v-if="props.icon"
                    :icon="props.icon"
                    class="align-self-center"
                />
                <span
                    class="flex-fill align-self-center"
                    v-html="$tm(text, '', true)"
                ></span>
                <ButtonComp
                    v-if="props.buttontext"
                    button-type="Info"
                    class="btn-sm"
                    icon="fa-plus"
                    @click="handleClick"
                    >{{ $tm(buttontext!) }}</ButtonComp
                >
            </div>
        </AlertMessage>
    </div>
</template>

<script lang="ts" setup>
import { useEventCommonStoreRef, useEventStoreRef } from '@/stores';
import AlertMessage from './AlertMessage.vue';
import { ButtonComp, IconComp } from '@/components';
import { Router } from '@/objects/Router';
import { $tm } from '@/locize';

const { eventID } = useEventStoreRef();

const props = defineProps<{
    /**
     * The key of the page to navigate to when the button is clicked
     * This will try and open the page with the id 'new' in the tab 'general'
     */
    page: string;

    /**
     * The text to display in the alert message
     */
    text: string;

    /**
     * The text to display in the button
     * if not provided there will be no button
     */
    buttontext?: string;

    /**
     * The icon to display in the button
     */
    icon?: string;
}>();

const comStore = useEventCommonStoreRef();

const handleClick = async () => {
    await Router.NavigateTo({ eventID: eventID.value, id: undefined, tab: 'general' }, props.page);
    await Router.NavigateTo({ eventID: eventID.value, id: 'new', tab: 'general' }, props.page);
    emits('createClicked');
};

const emits = defineEmits<{
    (e: 'createClicked'): void;
}>();
</script>
